import AppRecord from './AppRecord.js'

class ReportingType extends AppRecord {
  constructor(rec){
    super(rec)
  }
}

export default ReportingType

